<div class="gift--banner" *ngIf="gifts.length > 0">
  <ui-svg-icon svgIcon="reward" size="medium"></ui-svg-icon>
  <span *ngIf="gifts.length === 1" [innerHTML]="getGiftMessage(gifts[0]).message"></span>
  <span *ngIf="gifts.length > 1" class="multiple-gifts">
    {{ gifts.length }} {{ 'pricebook.rewards.available_promotions' | translate }} <span class="see-details" (click)="showDetails()">{{ 'pricebook.rewards.see_details' | translate }} <ui-svg-icon svgIcon="arrow-right-cc" size="small"></ui-svg-icon></span> 
  </span>
</div> 